import { EXPORT_NAME } from '../../../views/batches/BatchesListPage';
import { BASE_URL } from '../../../../config/environmentConfig';
import { orderActionTypes } from '../order-action-types';
import download from 'downloadjs';
import * as React from 'react';
import { IOrderAction } from '../order-interfaces';
import { GET } from '../../store-helper';
import { IBatchesFiltersParams } from '../../../components/batches/BatchesFilterSection';
import { BATCHES_TABS } from '../../../routing/batchesRoutes';

interface IExportBatchesCSVData {
	exportName: string;
	params: IBatchesFiltersParams;
}

export const exportCSVBatchesData = async ({ exportName, params }: IExportBatchesCSVData): Promise<void> => {
	try {
		let exportTitle = '';
		switch (exportName) {
			case EXPORT_NAME.PAYOUT:
				exportTitle = 'Batches';
				break;
			case EXPORT_NAME.UNPOSTED_PAYOUT:
				exportTitle = 'Unposted batches';
		}

		const data = await GET({ pathname: `${BASE_URL.ORDERS}/payouts/${exportName}?responseType=blob`, params });

		const blob = new Blob([data], { type: 'text/csv' });
		download(blob, `${exportTitle}.csv`);
	} catch (e) {
		console.log(e);
	}
};

export const exportCSVSettlementsDetails = async (dispatch: React.Dispatch<IOrderAction>, id: string, size: number): Promise<void> => {
	dispatch({ type: orderActionTypes.START_EXPORT_CSV_LOADING });
	try {
		const params = {
			pageSize: size,
			pageNumber: 1,
			responseType: 'blob'
		};

		const data = await GET({ pathname: `${BASE_URL.ORDERS}/settlements/${id}/export-details`, params });

		const blob = new Blob([data], { type: 'text/csv' });
		download(blob, 'Settlement details.csv');
		dispatch({ type: orderActionTypes.END_EXPORT_CSV_LOADING });
	} catch (e) {
		console.log(e);
		dispatch({ type: orderActionTypes.END_EXPORT_CSV_LOADING });
	}
};

export const exportCSVBatchDetailsData = async (id: string, size: number, locationPathname: BATCHES_TABS): Promise<void> => {
	try {

		let exportName = '';

		switch (locationPathname) {
			case BATCHES_TABS.BATCHES:
				exportName = 'Batch details';
				break;
			case BATCHES_TABS.UNPOSTED_BATCHES:
				exportName = 'Unposted batch details';
				break;
			case BATCHES_TABS.SHELVED_BATCHES:
				exportName = 'Shelved batch details';
				break;
		}

		const params = {
			pageSize: size,
			pageNumber: 1,
			responseType: 'blob'
		};

		const data = await GET({ pathname: `${BASE_URL.ORDERS}/payouts/${id}/export-details`, params });

		const blob = new Blob([data], { type: 'text/csv' });
		download(blob, `${exportName}.csv`);
	} catch (e) {
		console.log(e);
	}
};

export const exportCSVShelvedPayouts = async (id?: string): Promise<void> => {
	try {
		const exportTitle = 'Shelved payouts';
		let url = `${BASE_URL.ORDERS}/payouts/export-shelve?responseType=blob`;
		if (id) {
			url += `&merchantid=${id}`;
		}

		const data = await GET({ pathname: url });

		const blob = new Blob([data], { type: 'text/csv' });
		download(blob, `${exportTitle}.csv`);
	} catch (e) {
		console.log(e);
	}
};
